import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

/* ordre d'affichage de droite à gauche */
const SLOTS = ["chatbot", "timeclock", "page"];

const slotId = (slot) => `floating-dock-${slot}`;

/**
 * Conteneur unique des boutons flottants en bas à droite (chatbot, badgeuse,
 * actions de page). Chaque bouton s'y injecte via FloatingDockPortal pour
 * s'aligner sans se chevaucher.
 */
const FloatingDock = () => (
    <Dock>
        {SLOTS.map((slot) => (
            <Slot key={slot} id={slotId(slot)} />
        ))}
    </Dock>
);

export default FloatingDock;

/** Rend ses enfants dans le slot `slot` du dock */
export const FloatingDockPortal = ({ slot, children }) => {
    const [node, setNode] = useState(null);

    useEffect(() => {
        setNode(document.getElementById(slotId(slot)));
    }, [slot]);

    if (!node) return null;
    return createPortal(children, node);
};

const Dock = styled.div`
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 1000;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    gap: 12px;
    /* la zone vide entre les boutons laisse passer les clics */
    pointer-events: none;
`;

const Slot = styled.div`
    display: flex;
    pointer-events: auto;

    &:empty {
        display: none;
    }
`;
